import React from 'react';
import { IconButton } from 'src/common/icon-button';
import { LeftStrongIcon } from 'src/monet/icons';
import { BreadcrumbsConfig, MetricCard } from './constants';
import { BreadCrumbsComponent } from 'src/common/breadcrumbs/component';
import { EditorInsightsAggregateMetricsCard } from 'src/editor/insights/aggregate-metrics-card';
import { useHistory } from 'react-router-dom';
import { Nullable } from 'src/types/nullable.type';

type Props = {
  headerSection: Nullable<string | JSX.Element>;
  breadcrumbsConfig: BreadcrumbsConfig;
  metricCards: MetricCard[];
  contentSection: Nullable<string | JSX.Element>;
};

export const DashboardInsightsItemLayout = ({
  headerSection,
  breadcrumbsConfig,
  metricCards,
  contentSection,
}: Props) => {
  const history = useHistory();
  return (
    <>
      <div className='flex flex-col w-full'>
        <div className='flex flex-col gap-6'>
          <div className='mt-md flex gap-2'>
            <IconButton onClick={() => history.goBack()}>
              <LeftStrongIcon />
            </IconButton>
            <BreadCrumbsComponent
              value={breadcrumbsConfig.items[breadcrumbsConfig.items.length - 1].value}
              items={breadcrumbsConfig.items.map((bci) => bci.value)}
              itemClassNames={breadcrumbsConfig.items.map((i, index) =>
                index === breadcrumbsConfig.items.length - 1
                  ? 'max-w-[240px] overflow-hidden whitespace-nowrap text-ellipsis'
                  : ''
              )}
              onItemClick={(option, index) => {
                const bci = breadcrumbsConfig.items[index];
                bci.onClick && bci.onClick();
              }}
            />
          </div>
          <div className='flex flex-col items-start pb-0 bg-bedrock-white insights-overview'>
            {headerSection}
            <div className='mt-6 flex gap-2'>
              {metricCards.map((card) => (
                <div className='min-w-[172px]' key={card.key}>
                  <EditorInsightsAggregateMetricsCard
                    label1={`${card.value}`}
                    label2={card.title}
                    tooltip={card.tooltip}
                    delta={card.delta}
                  />
                </div>
              ))}
            </div>
            <div className='mt-16 w-full min-h-[40vh]'>{contentSection}</div>
          </div>
        </div>
      </div>
    </>
  );
};
